import angular from "angular";

let TrainingCentersFactory = angular
  .module("TrainingCentersFactory", [])
  .factory("TrainingCentersFactory", ($rootScope, $http, HttpFactory, URLS) => {
    "ngInject";
    return {
      getAll: (params) => {
        let parameters = Object.assign({ page_size: 2000 }, params);
        return HttpFactory.get(URLS.TRAINING_CENTERS, parameters);
      },
      getOne: (trainingEntryId, params) => {
        let url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
        let parameters = Object.assign({}, params);
        return HttpFactory.get(url, parameters);
      },
      create: (data) => {
        return HttpFactory.post(URLS.TRAINING_CENTERS, data);
      },
      update: (trainingEntryId, data) => {
        let url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
        return HttpFactory.put(url, data);
      },
      delete: (trainingEntryId) => {
        let url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
        return HttpFactory.delete(url);
      },
    };
  }).name;

export default TrainingCentersFactory;



// WEBPACK FOOTER //
// ./client/app/services/trainingCenters.factory.js